import { Component, Input, OnInit } from "@angular/core";
import { WebRecentActivity } from "src/app/models";
import { MediaObserver } from "@angular/flex-layout";

@Component({
  selector: "app-recent-activity",
  templateUrl: "./recent-activity.component.html",
  styleUrls: ["./recent-activity.component.scss"]
})
export class RecentActivityComponent implements OnInit
{

  @Input() activities: WebRecentActivity[] = [];


  constructor(
    public media: MediaObserver
  ) { }

  ngOnInit(): void
  {

  }

}
